import React from "react"
import { Box, Flex, Heading } from "@chakra-ui/react"
import useEmblaCarousel from "embla-carousel-react"

import { useLiveProducts } from "@app/hooks/useLiveProducts"
import ProductCard from "@app/components/ProductCard/ProductCard"
import Icon from "@app/components/Icon"

type Props = {
  products?: any
  featureProductHeading?: string
}

const SearchResultsFeaturedProducts: React.FC<Props> = ({ products, featureProductHeading }) => {
  const { liveProducts } = useLiveProducts(products, false)

  const [emblaRef, emblaApi] = useEmblaCarousel({
    loop: true,
    align: "start",
    inViewThreshold: 0.6,
  })

  return liveProducts?.length > 0 ? (
    <Box bgColor="grey.lightest" pt={5}>
      <Box maxW="container.lg" mx="auto" py={5}>
        <Box textAlign="center">
          <Heading size="h5" mb={2.5} color="primary.midGrey" fontWeight="medium">
            <Box transform={{ base: "none", sm: "scale(1.2)" }} pos="relative" left={{ base: 0, sm: "-8px" }} display="inline-block">
              <Icon
                name="shootingStar"
                color="primary.midGrey"
                fill="primary.white"
                title="Shooting Star Icon"
                height="23px"
                width="22px"
              />
            </Box>
            {featureProductHeading}
          </Heading>
        </Box>
        <Box pos="relative" w="100%" p={5}>
          <Box overflow="hidden" pt={5} ref={emblaRef}>
            <Flex alignItems="stretch" w="100%">
              {liveProducts?.map((product: any, index: number) => (
                <Box
                  key={`${product?.handle}${index}`}
                  p={2.5}
                  display="flex"
                  flexWrap="wrap"
                  w={{ base: "50%", md: "33.333333%", lg: "25%" }}
                  mb={2.5}
                  minW="25%"
                  flex="0 0 auto"
                  pos="relative"
                >
                  <ProductCard item={product} color="primary.white" w="100%" />
                </Box>
              ))}
            </Flex>
          </Box>
          <Box
            cursor="pointer"
            pos="absolute"
            top="50%"
            w={2.5}
            transform="translateY(-50%)"
            right={2}
            onClick={() => emblaApi?.scrollNext()}
          >
            <Icon name="chevronRight" width="9px" height="16px" />
          </Box>
          <Box
            cursor="pointer"
            pos="absolute"
            top="50%"
            w={2.5}
            transform="translateY(-50%)"
            left={2}
            onClick={() => emblaApi?.scrollPrev()}
          >
            <Icon name="chevronRight" width="9px" height="16px" transform="rotateZ(180deg)" />
          </Box>
        </Box>
      </Box>
    </Box>
  ) : null
}

export default React.memo(SearchResultsFeaturedProducts)
